module.exports = __webpack_public_path__ + "img/20_117.43fca49b.png";